//
//
//
//
//
//
//
//
//
export default {
  name: 'SuperAdmin',
  data: function data() {
    return {
      isRouterAlive: true
    };
  },
  created: function created() {
    console.log('created SuperAdmin');
  },
  activated: function activated() {
    var _this = this;

    console.log('activated SuperAdmin');
    this.isRouterAlive = false;
    this.$nextTick(function () {
      return _this.isRouterAlive = true;
    });
  }
};